export const parseJackpotGameProvider = (provider: string) =>
  provider
    .toLowerCase()
    .split(' ')
    .join('');
